import Cookies from 'js-cookie';
import { decode } from 'base-64';

export const getVehicleType = () => {
  const vt = Cookies.get('vehicletype');
  return vt ? decode(vt) : '';
};

export const is3w = () => getVehicleType() === '3W';
export const is2w = () => !is3w();
